export default __webpack_public_path__ + "static/media/oreoluwa.f6be582f.jpg";